<template>
  <v-chip
    pill
    dark
    :style="{ minWidth: width }"
    :class="['pill-container', { 'pill-text': onlyText }]"
    :color="chipColor"
  >
    <slot />
  </v-chip>
</template>

<script>
  import statusColor from '@/mixins/statusColor';

  export default {
    name: 'ItemStatus',
    mixins: [statusColor],
    props: {
      color: {
        type: String,
        default: null,
      },
      status: {
        type: String,
        required: true,
      },
      type: {
        type: String,
        default: 'pill',
      },
      width: {
        type: String,
        default: '70px',
      },
      onlyText: Boolean,
    },
    computed: {
      chipColor() {
        if (this.onlyText) return 'transparent';
        if (this.color) return this.color;

        return this.getStockStatusColor(this.status);
      },
    },
  };
</script>

<style scoped>
  .pill-container {
    justify-content: center;
    text-align: center;
    margin: auto;
    min-width: var(--width);
  }

  .pill-text {
    color: var(--color) !important;
  }
</style>
